import { render, staticRenderFns } from "./audit_table.vue?vue&type=template&id=2d2f2ca0&"
import script from "./audit_table.vue?vue&type=script&lang=js&"
export * from "./audit_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports